import { computed, reactive, watch } from 'vue'

const state = reactive({
  view: 'room',
})

watch(
  () => state.view,
  () => {
    const header = document.querySelector('header')
    const el = document.getElementById('roomRent')
    scroll({
      top: el.offsetTop - header.offsetHeight - 100,
    })
  }
)

export function setRoomView() {
  state.view = 'room'
}

export const isRoomView = computed(() => {
  return state.view === 'room'
})

export function setUserDetailsView() {
  state.view = 'user_details'
}

export const isUserDetailsView = computed(() => {
  return state.view === 'user_details'
})

export function setAmountServiceView() {
  state.view = 'amount_service'
}

export const isAmountServiceView = computed(() => {
  return state.view === 'amount_service'
})

export function setSelectServiceView() {
  state.view = 'select_service'
}

export const isSelectServiceView = computed(() => {
  return state.view === 'select_service'
})

export function setOverviewView() {
  state.view = 'overview'
}

export const isOverviewView = computed(() => {
  return state.view === 'overview'
})

export function setPayView() {
  state.view = 'pay'
}

export const isPayView = computed(() => {
  return state.view === 'pay'
})

export function setPayReturnView() {
  state.view = 'pay_return'
}

export const isPayReturnView = computed(() => {
  return state.view === 'pay_return'
})

export function setCancelRequestedView() {
  state.view = 'cancel_requested'
}

export const isCancelRequestedView = computed(() => {
  return state.view === 'cancel_requested'
})
